export default __webpack_public_path__ + "static/media/music-player.6415332c.svg";